import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import DoctorAutocomplete from './DoctorAutocomplete';

loadDOMComponent({
	selector: 'react-doctor-autocomplete',
	callback: ({ container }) => {
		const searchUrl = container.getAttribute('data-search-url');
		const placeholder = container.getAttribute('placeholder');
		const id = container.getAttribute('data-target-hidden-id');

		// @ts-ignore
		const defaultValue = document.querySelector(
			"[data-hidden-id='" + id + "']",
		).value;

		const handleChanged = value => {
			if (Array.isArray(value)) {
				value.map(item => item.id).join(',');
			} else {
				value = value?.id;
			}

			const element = document.querySelector("[data-hidden-id='" + id + "']");

			// @ts-ignore
			element.value = value;

			// @ts-ignore
			element
				.closest('form')
				.dispatchEvent(new Event('submit', { bubbles: true }));
		};

		ReactDOM.render(
			<AppContextProvider>
				<DoctorAutocomplete
					searchUrl={searchUrl}
					onChange={handleChanged}
					placeholder={placeholder}
					value={defaultValue}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
